import { COLORS } from '@/constants';
import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  @media (max-width: 780px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ControlsBtn = styled.button`
  gap: 10px;
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background: ${COLORS['neutral/50']};
  border-radius: 8px;
  border: 1px solid ${COLORS['neutral/300']};
  width: 100%;
  cursor: pointer;

  svg {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }

  &:hover {
    color: ${COLORS['secondary/500']};
  }

  @media (max-width: 780px) {
    padding: 8px 10px;
    gap: 8px;

    svg {
      width: 24px;
      height: 24px;
    }
  }
`;
